import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { MaterialHint, Button } from 'shared/components';
import { redirectTo } from 'modules/auth/actions/redirectAction';

import { AuthorizedUserIcon } from '../';

import theme from './AccountDetailsTooltip.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  logoutWithModal: PropTypes.func.isRequired,
  closeTooltip: PropTypes.func.isRequired,
  userFullName: PropTypes.string.isRequired,
  userEmail: PropTypes.string.isRequired,
  userIsOnCall: PropTypes.bool.isRequired,
  userReadPermissions: PropTypes.object.isRequired,
};

const AccountDetailsTooltip = ({ intl, logoutWithModal, closeTooltip, userFullName, userEmail, userIsOnCall, userReadPermissions, isMyAccountFeatureEnabled }) => (
  <Fragment>
    <div className={ theme.container }>
      <div className={ theme.userIconContainer }>
        <AuthorizedUserIcon className={ theme.userIcon } />
      </div>

      <div className={ theme.userInfoContainer }>
        <div>
          { userFullName }
        </div>

        <div>
          { userEmail }
        </div>
      </div>
    </div>

    <div className={ theme.footer }>
      <Choose>
        <When condition={ userReadPermissions.canSeeUserAccount && isMyAccountFeatureEnabled }>
          <MaterialHint
            placement="bottom"
            title={ userIsOnCall
              ? intl.formatMessage({ id: 'Patient.MyAccount.OnACall.Tooltip', defaultMessage: 'My account is not accessible during a call' })
              : intl.formatMessage({ id: 'Patient.MyAccount.Tooltip', defaultMessage: 'Access your details' })
            }
          >
            <div>
              <Button
                testId="my-account-button"
                onClick={ () => {
                  closeTooltip();
                  if (!userIsOnCall) redirectTo('/profile');
                } }
                className={ classnames(theme.myAccountBtn, { [theme.myAccountDisabled]: userIsOnCall }) }
                buttonType="naked"
                label={ intl.formatMessage({ id: 'Patient.MyAccount.Button', defaultMessage: '** My account' }) }
                iconName="my-account"
                size="small"
                iconPositionLeft
              />
            </div>
          </MaterialHint>
        </When>
        <Otherwise>
          <div />
        </Otherwise>
      </Choose>
      <Button
        testId="sign-out-button"
        buttonType="naked"
        label={ intl.formatMessage({ id: 'SessionTermination.Label.SignoutBtn', defaultMessage: '** Sign out' }) }
        iconName="signout"
        size="small"
        onClick={ logoutWithModal }
        iconPositionLeft
      />
    </div>
  </Fragment>
);

AccountDetailsTooltip.propTypes = propTypes;

export default AccountDetailsTooltip;
